export function initializeChart(am4core, am4charts, am4lang_ru_RU, chartId) {
    const chart = am4core.create(chartId, am4charts.XYChart);

    if (am4lang_ru_RU) {
        chart.language.locale = am4lang_ru_RU;
    }

    chart.logo.disabled = true;
    chart.zoomOutButton.disabled = true;
    chart.maskBullets = false;
    chart.plotContainer.background.strokeWidth = 1;
    chart.plotContainer.background.strokeOpacity = 0;
    chart.plotContainer.background.stroke = am4core.color("#fff");
    chart.paddingTop = 20;
    chart.paddingBottom = 0;
    chart.paddingRight = 15;
    chart.paddingLeft = 15;
    chart.hiddenState.properties.opacity = 0;
    chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm";
    chart.plotContainer.paddingLeft = 0;

    return chart;
}

export function setupAxes(chart, am4charts) {
    // Category Axis (Y)
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "id";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.cellStartLocation = 0.1;
    categoryAxis.renderer.cellEndLocation = 0.9;
    categoryAxis.renderer.grid.template.disabled = true;

    // Date Axis (X)
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.fontSize = '12px';
    dateAxis.dateFormatter.dateFormat = "YYYY-MM-DD";
    dateAxis.renderer.minGridDistance = 50;
    dateAxis.baseInterval = { count: 1, timeUnit: "month" };
    dateAxis.renderer.grid.template.location = 0.5;
    dateAxis.gridIntervals.setAll([
        { timeUnit: "year", count: 1 },
    ]);
}

export function setupDateRange(dateAxis, earlierDate, olderDate) {
    const diff = Math.abs(earlierDate.diff(olderDate, 'year'));

    let adjustedOlderDate = olderDate;
    if (diff < 4) {
        adjustedOlderDate = earlierDate.clone().add(5, 'years');
    }

    dateAxis.min = earlierDate.clone().subtract(1, 'years').startOf('year').toDate().getTime();
    dateAxis.max = adjustedOlderDate.toDate().getTime();
}

export function setupSeries(chart, am4charts, am4core, onGoalClick) {
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.columns.template.width = am4core.percent(100);
    series.columns.template.height = 26;
    series.dataFields.openDateX = "fromDate";
    series.dataFields.dateX = "toDate";
    series.dataFields.categoryY = "id";
    series.columns.template.propertyFields.fill = "color";
    series.columns.template.propertyFields.stroke = "color";
    series.columns.template.strokeOpacity = 1;
    series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    series.columns.template.column.cornerRadius(4, 4, 4, 4);

    series.columns.template.events.on("hit", (ev) => {
        const id = ev.target.dataItem.dataContext.id;
        if (parseInt(id) && onGoalClick) {
            onGoalClick(id);
        }
    });

    return series;
}

export function setupDynamicHeight(chart, minHeight, setContainerHeight) {
    const cellSize = 40; // Высота одной строки (26px высота колонки + отступы)

    const updateHeight = () => {
        const categoryAxis = chart.yAxes.getIndex(0);
        // Считаем количество категорий (уникальных строк)
        const categoriesCount = categoryAxis.dataItems.length;

        // Рассчитываем целевую высоту: количество строк * размер ячейки + отступы
        let targetHeight = categoriesCount * cellSize + 100; // 100px на оси и отступы

        if (targetHeight < minHeight) {
            targetHeight = minHeight;
        }

        // Обновляем высоту SVG контейнера графика
        chart.svgContainer.htmlElement.style.height = targetHeight + "px";

        // Обновляем высоту внешнего контейнера через setState
        if (setContainerHeight) {
            setContainerHeight(targetHeight);
        }
    };

    // Пробуем несколько событий для надежности
    chart.events.on("datavalidated", updateHeight);
    chart.events.on("ready", updateHeight);

    // Принудительно вызываем валидацию данных
    chart.invalidateData();
}
